/* eslint-disable max-len */
import React, { useContext } from 'react';
import classNames from 'classnames';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { StoreContext } from '../../context/store-context';

import Link from '../Link';

import renderIcon from '../../utils/renderIcon';

const ns = `account-button`;

const AccountButton = ({ closeMenu }) => {
	const {
		accounts,
	} = useMsal();

	const {
		loginUser,
		customer,
		isLoginDisabled,
		setAlertModal,
	} = useContext(StoreContext);

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--logged-in`]: accounts.length,
	});

	if (isLoginDisabled) {
		return (
			<button
				className={rootClassnames}
				aria-label={`Go to login`}
				onClick={() => {
					closeMenu?.();
					setAlertModal(() => true);
				}}
			>
				{renderIcon('profile')}
				{' '}
				<span className={`underline ${ ns }__mobile`}>Sign In</span>
			</button>
		);
	}

	return (
		<>
			<AuthenticatedTemplate>
				<Link
					aria-label={`Go to account`}
					to={'/account'}
					className={rootClassnames}
					onClick={closeMenu}
				>
					{renderIcon('profile')}
					{' '}
					<span className={`underline ${ ns }__mobile`}>My Account</span>
					<span className={`${ ns }__desktop`}>{customer.fullName || customer.email}</span>
				</Link>
			</AuthenticatedTemplate>
			<UnauthenticatedTemplate>
				<button
					className={rootClassnames}
					aria-label={`Go to login`}
					onClick={loginUser}
				>
					{renderIcon('profile')}
					{' '}
					<span className={`underline ${ ns }__mobile`}>Sign In</span>
				</button>
			</UnauthenticatedTemplate>
		</>
	);
};

export default AccountButton;
